module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "play"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "time_div"
  }, [_c('p', {
    staticClass: "time_p1"
  }, [_vm._v("答对四题拼红包")]), _vm._v(" "), _c('p', {
    staticClass: "time_p2"
  }, [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), _c('div', {
    staticClass: "pt"
  }, _vm._l((_vm.coverImgs), function(item) {
    return _c('img', {
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), 0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "bounceInRight"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return (index == _vm.questionIndex) ? _c('div', {
      key: item.id,
      staticClass: "content"
    }, [_c('div', {
      staticClass: "title_div"
    }, [_c('img', {
      attrs: {
        "src": "http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%AD%94%E9%A2%98%E9%A1%B5-%E9%97%AE%E9%A2%98@2x.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v("\r\n          " + _vm._s(item.title) + "\r\n\r\n        ")])]), _vm._v(" "), _c('ul', _vm._l((item.option), function(item2, index2) {
      return (item2.name) ? _c('li', {
        key: item2.name,
        class: [index2 == _vm.activeIndex ? 'active' : 'notActive'],
        on: {
          "click": function($event) {
            return _vm.activeClick(item2, index2, item)
          }
        }
      }, [_vm._v("\r\n          " + _vm._s(item2.name) + "\r\n        ")]) : _vm._e()
    }), 0)]) : _vm._e()
  }), 0), _vm._v(" "), _c('resurrection', {
    attrs: {
      "show-log": _vm.showLog,
      "question-index": _vm.questionIndex,
      "question-list": _vm.list,
      "revive-num": _vm.reviveNum,
      "integral": _vm.integral
    },
    on: {
      "update:showLog": function($event) {
        _vm.showLog = $event
      },
      "update:show-log": function($event) {
        _vm.showLog = $event
      },
      "revive-card": _vm.useReviveCard
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-26caf0e9"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/Play/index.vue
// module id = 232
// module chunks = 1